import React from "react";
import Instruction from "../components/Instruction";

import createState from "../assets/tutorial/create_state.mp4";
import editState from "../assets/tutorial/edit_state.mp4";
import moveState from "../assets/tutorial/move_state.mp4";

import signIn from "../assets/tutorial/signIn.mp4";
import autoAlphabet from "../assets/tutorial/auto_alphabet.mp4";
import editAlphabet from "../assets/tutorial/edit_alphabet.mp4";

import createTransition from "../assets/tutorial/create_transition.mp4";
import editTransition from "../assets/tutorial/edit_transition.mp4";
import moveTransition from "../assets/tutorial/move_transition.mp4";

import recognizeString from "../assets/tutorial/recognize_string.mp4";
import remaneMachine from "../assets/tutorial/remane_machine.mp4";
import settings from "../assets/tutorial/settings.mp4";


const canvasInstructions = [
	{
		title: "Mover estados",
		description: "Arrastra sobre el estado que deseas mover.",
		imageSrc: moveState,
	},
	{
		title: "Mover transiciones",
		description:
			"Para modificar el trazado de las flechas que representan cada transición, arrastra sobre los símbolos de la transición que deseas mover.",
		imageSrc: moveTransition,
	},
	{
		title: "Crear estados",
		description: "Haz doble clic sobre el canvas en blanco.",
		imageSrc: createState,
	},
	{
		title: "Editar nodos",
		description: "Haz doble clic sobre el estado que deseas editar.",
		imageSrc: editState,
	},
	{
		title: "Crear transiciones",
		description:
			'Mantén presionada la tecla "shift" y luego haz clic sobre el estado desde el cual comenzará la nueva transición. \n Luego, manteniendo presionada la tecla "shift", haz clic sobre el estado donde finalizará la transición.',
		imageSrc: createTransition,
	},
	{
		title: "Editar transiciones",
		description:
			"Haz doble clic sobre los símbolos de la transición que deseas editar.",
		imageSrc: editTransition,
	},
];

const settingsInstructions = [
	{
		title: "Información general",
		description:
			"En este panel puedes consultar el conjunto de estados del autómata, cúal es el inicial y cuáles son finales. Además puedes ver el nombre del autómata y su alfabeto.",
		imageSrc: settings,
	},
	{
		title: "Renombre el autómata",
		description: "Haz clic sobre el nombre del autómata para editarlo.",
		imageSrc: remaneMachine,
	},
	{
		title: "Modificar el alfabeto",
		description:
			'Escribe los símbolos del alfabeto separados por comas, luego presiona "Actualizar".',
		imageSrc: editAlphabet,
	},
	{
		title: "Alfabeto automático",
		description:
			'Presiona "Automático" para que el alfabeto se actualice automáticamente. Al crear una nueva transición, si esta incluye símbolos que no pertenecían al alfabeto, serán añadidos automáticamente.',
		imageSrc: autoAlphabet,
	},
];

const playerInstructions = [
	{
		title: "Renocimiento de cadenas",
		description:
			'En este panel puedes pedirle al autómata que intente reconocer una cadena. Escribe la cadena en el campo señalado y presiona "Reconocer"',
		imageSrc: recognizeString,
	},
];

const authInsctructions = [
	{
		title: "Inicio de sesión",
		description:
			'Haz clic sobre el icono de usuario en la parte superior derecha de la pantalla, luego presiona "Iniciar Sesión". Se abrirá una nueva ventana para que elijas la cuenta de Google con la que iniciarás sesión. Los autómatas que crees se vincularán a esta cuenta y se guardrán en la nube para accederlos desde cualquier computadora.',
		imageSrc: signIn,
	},
];
export default function Tutorial() {
	return (
		<div className="page tutorial">
			<div className="page-header">
				<h1 className="page-title">Guardado en la nube</h1>
			</div>
			<div className="instructions">
				{authInsctructions.map((instruction, index) => {
					return (
						<Instruction instruction={instruction} key={index} />
					);
				})}
			</div>
			<div className="page-header">
				<h1 className="page-title">Editar el autómata</h1>
			</div>
			<div className="instructions">
				{canvasInstructions.map((instruction, index) => {
					return (
						<Instruction instruction={instruction} key={index} />
					);
				})}
			</div>
			<div className="page-header">
				<h1 className="page-title">Configurar el autómata</h1>
			</div>
			<div className="instructions">
				{settingsInstructions.map((instruction, index) => {
					return (
						<Instruction instruction={instruction} key={index} />
					);
				})}
			</div>
			<div className="page-header">
				<h1 className="page-title">Ejecutar el autómata</h1>
			</div>
			<div className="instructions">
				{playerInstructions.map((instruction, index) => {
					return (
						<Instruction instruction={instruction} key={index} />
					);
				})}
			</div>
		</div>
	);
}
